export default __webpack_public_path__ + "static/media/BATD_Euro.0c3a36a3.webp";